export default "__VITE_ASSET__BMYAqwbT__"